import moment from "moment";
import { ZatcaDeviceStatus } from "../configs/constants";

export const deviceNeedsZatcaReonboarding = (device) =>
  device?.status === ZatcaDeviceStatus.NeedsReonboarding ||
  Boolean(device?.requires_reonboarding_at);

export const isZatcaDeviceBlockingOnboarding = (
  device,
  environment,
  now = moment(),
) => {
  if (!device || !environment || device.environment !== environment) {
    return false;
  }

  if (
    deviceNeedsZatcaReonboarding(device) ||
    device.status === ZatcaDeviceStatus.CsidExpired
  ) {
    return false;
  }

  const expiry = device.production_expires_at
    ? moment(device.production_expires_at)
    : null;

  return !(expiry?.isValid() && expiry.isBefore(moment(now)));
};
